import { render, staticRenderFns } from "./Participants2.vue?vue&type=template&id=97021e0a"
import script from "./Participants2.vue?vue&type=script&lang=js"
export * from "./Participants2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports